import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.model', ['app.principal','app.community']);
})();
